<h4 [attr.data-testid]="data.message + '_message'">Are you sure you want to publish new menus?</h4>
<div>
  <h6>
    You will be publishing {{ (storesIncludedEventCount$ | async) ?? eventCount }} menus.
  </h6>
</div>
<div class="checkbox-container">
  @if ((data.isSuperAdmin || data.isAdmin) && this.data.countryCode) {
    <mat-checkbox
      [disabled]="disableIncludeStores"
      [checked]="includeStores" (click)="handleIncludeStoresClicked()">
      <span class="checkbox-label">Include Stores?&nbsp;</span>
    </mat-checkbox>
  }
</div>
<footer>
  <button
    [attr.data-testid]="'dialog_no_button'"
    class="button-color"
    id="no-button"
    [mat-dialog-close]="false"
    mat-raised-button
    type="button"
    (click)="closeDialog()"
    >
    No
  </button>
  <button
    [attr.data-testid]="'dialog_yes_button'"
    class="button-color"
    id="yes-button"
    [mat-dialog-close]="true"
    mat-raised-button
    type="button"
    (click)="publish()"
    >
    Yes
  </button>
</footer>
